import {
  Title,
  SimpleReactValidator,
  Messages,
  API,
  HttpService,
  FileUploadWithPreview,
  getBase64,
  toast,
  Spinner,
  DropdownTreeSelect,
  React,
  Common
} from '../../../config/react'
import { useParams, useHistory, Link, useLocation } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react'

const AddSectionOption = () => {
  const urlParams = useParams()
  const history = useHistory()
  const location = useLocation()
  const validator = useRef(
    new SimpleReactValidator({
      validators: {
        noDomain: {
          message: 'Custom links cannot contain a domain.',
          rule: (val) => !/^(https?:\/\/|www\.)/i.test(val), // Rejects if input contains a domain
          required: true
        }
      }
    })
  )
  const [IsAuth, setIsAuth] = useState(false)
  const [isForceUpdate, setForceUpdate] = useState(false)

  const [DeskImg, setDeskImg] = useState('invalid')
  const [IsDesktopImage, setDesktopImage] = useState(true)
  const [IsDesktopValidFile, setDesktopValidFile] = useState(true)
  const [IsDesktopImageSize, setDesktopImageSize] = useState(false)
  // const [IsDesktopShowImageRemoveLink, setIsDesktopShowImageRemoveLink] = useState(false)

  const [MobileImg, setMobileImg] = useState('')
  const [IsMobileImage, setMobileImage] = useState(true)
  const [IsMobileValidFile, setMobileValidFile] = useState(true)
  const [IsMobileImageSize, setMobileImageSize] = useState(false)
  //  const [IsMobileShowImageRemoveLink, setIsMobileShowImageRemoveLink] = useState(false)

  const [Categories, setCategories] = useState([])
  const [loading, setLoading] = useState(false)
  const [Pages, setPages] = useState([])

  const [desktopHoverInfo, setDesktopHoverInfo] = useState(null)
  const [mobileHoverInfo, setMobileHoverInfo] = useState(null)

  // const [DiamondShapeCategories, setDiamondShapeCategories] = useState([])

  const [Inputs, setInputs] = useState({
    id: 0,
    section_id: 0,
    section_name: '',
    title: '',
    description: '',
    link_type: '',
    link: '',
    external_link: '',
    status: 0,
    category_id: '',
    page_id: '',
    desktop_img: '',
    mobile_img: '',
    selectedCategoryId: '',
    selectedMenu: '',
    section_type: '',
    DesktopbtnX: '',
    DesktopbtnY: '',
    MobilebtnX: '',
    MobilebtnY: '',
    desk_btn_theme: 'white',
    mob_btn_theme: 'white'
  })
  const [DesktopBtnPosition, setDesktopBtnPosition] = useState(null)
  const [MobileBtnPosition, setMobileBtnPosition] = useState(null)
  const DesktopImageRef = useRef(null)
  const MobileImageRef = useRef(null)
  useEffect(() => {
    document.title = Title.AddSectionOption
    setIsAuth(true)
    if (urlParams.id !== undefined) {
      document.title = Title.EditSectionOption
      GetSectionItemById()
    } else {
      GetCategoryList()
      const Sid = location.state.sid
      setInputs({ ...Inputs, section_id: Sid })
      setTimeout(() => {
        initDesktopImagePlugin()
        initMobileImagePlugin()
      }, 2000)
    }
    GetPageList()
  }, [urlParams.id])

  const handleDesktopImageHover = (e) => {
    const rect = DesktopImageRef.current.getBoundingClientRect()

    const x = ((e.clientX - rect.left) / rect.width) * 100
    const y = ((e.clientY - rect.top) / rect.height) * 100

    setDesktopHoverInfo({
      xPercent: x,
      yPercent: y,
      buttonNumber: 1
    })
  }

  const handleDesktopImageLeave = () => {
    setDesktopHoverInfo(null)
  }
  const handleMobileImageHover = (e) => {
    const rect = MobileImageRef.current.getBoundingClientRect()

    const x = ((e.clientX - rect.left) / rect.width) * 100
    const y = ((e.clientY - rect.top) / rect.height) * 100

    setMobileHoverInfo({
      xPercent: x,
      yPercent: y,
      buttonNumber: 1
    })
  }

  const handleMobileImageLeave = () => {
    setMobileHoverInfo(null)
  }
  const handleRemoveDesktopButton = () => {
    setDesktopBtnPosition(null)
  }

  const handleRemoveMobileButton = () => {
    setMobileBtnPosition(null)
  }

  // desktop btn
  const handleDesktopImageClick = (event) => {
    const rect = DesktopImageRef.current.getBoundingClientRect()
    const xPercentDesk = ((event.clientX - rect.left) / rect.width) * 100
    const yPercentDesk = ((event.clientY - rect.top) / rect.height) * 100
    setDesktopBtnPosition({ xPercentDesk, yPercentDesk })
    setInputs({ ...Inputs, DesktopbtnX: xPercentDesk, DesktopbtnY: yPercentDesk })
  }

  // mobile btn
  const handleMobileImageClick = (event) => {
    const rect = MobileImageRef.current.getBoundingClientRect()
    const xPercentMob = ((event.clientX - rect.left) / rect.width) * 100
    const yPercentMob = ((event.clientY - rect.top) / rect.height) * 100

    setMobileBtnPosition({ xPercentMob, yPercentMob })
    setInputs({ ...Inputs, MobilebtnX: xPercentMob, MobilebtnY: yPercentMob })
  }
  const GetCategoryList = (selectedCategory = null) => {
    HttpService.postApi(API.GetCategory, null).then((response) => {
      if (response.data.result) {
        // filter parent category
        const parentCategories = response.data.result[0].filter(
          (x) => x.parent_id === 1 && x.status
        )
        // setDiamondShapeCategories(response.data.result[0].filter(x => x.is_diamond_category === 1));
        // console.log(parentCategories)
        const categories = []

        parentCategories.map((item) => {
          // filter sub categories by parent
          const filteredSubcategories = response.data.result[0].filter(
            (x) => x.parent_id === item.id && x.status
          )
          const subcategories = []

          filteredSubcategories.map((subitem) => {
            // filter sub child categories by parent
            const filteredSubChildCategories = response.data.result[0].filter(
              (x) => x.parent_id === subitem.id && x.status
            )
            const subchildcategories = []

            filteredSubChildCategories.map((subchilditem) => {
              const filteredChildCategories = response.data.result[0].filter(
                (x) => x.parent_id === subchilditem.id && x.status
              )
              const childcategories = []

              filteredChildCategories.map((childitem) => {
                const filteredChildrenCategories = response.data.result[0].filter(
                  (x) => x.parent_id === childitem.id && x.status
                )
                const childrencategories = []
                filteredChildrenCategories.map((childrenitem) => {
                  let checked = false
                  if (
                    (urlParams.id !== undefined && Inputs.category_id === childrenitem.id) ||
                    selectedCategory === childrenitem.id
                  )
                    checked = true
                  childrencategories.push({
                    label: childrenitem.name,
                    value: childrenitem.id,
                    checked
                    // children: subcategories
                  })
                  return true
                })

                let checked = false
                if (
                  (urlParams.id !== undefined && Inputs.category_id === childitem.id) ||
                  selectedCategory === childitem.id
                )
                  checked = true
                childcategories.push({
                  label: childitem.name,
                  value: childitem.id,
                  checked,
                  children: childrencategories
                })
                return true
              })

              let checked = false
              if (
                (urlParams.id !== undefined && Inputs.category_id === subchilditem.id) ||
                selectedCategory === subchilditem.id
              )
                checked = true
              subchildcategories.push({
                label: subchilditem.name,
                value: subchilditem.id,
                checked,
                children: childcategories
              })
              return true
            })

            let checked = false
            if (
              (urlParams.id !== undefined && Inputs.category_id === subitem.id) ||
              selectedCategory === subitem.id
            )
              checked = true
            subcategories.push({
              label: subitem.name,
              value: subitem.id,
              checked,
              children: subchildcategories
            })
            return true
          })
          let checked = false
          if (
            (urlParams.id !== undefined && Inputs.category_id === item.id) ||
            selectedCategory === item.id
          )
            checked = true
          categories.push({
            label: item.name,
            value: item.id,
            children: subcategories,
            checked
          })
          return true
        })
        setCategories(categories)
      }
    })
  }

  const GetPageList = () => {
    HttpService.getApi(API.GetContentManagementList).then((response) => {
      setPages(response.data.result)
    })
  }
  const GetSectionItemById = () => {
    const param = {
      _id: urlParams.id.split('&')[0],
      _section_id: urlParams.id.split('&')[1]
    }

    HttpService.postApi(API.GetSectionItemById, param).then((response) => {
      if (response.data.result) {
        const data = response.data.result[0][0]
        const xPercentDesk = data.desk_btn_x_position
        const yPercentDesk = data.desk_btn_y_position
        const xPercentMob = data.mob_btn_x_position
        const yPercentMob = data.mob_btn_y_position
        setInputs({
          ...Inputs,
          id: data.id,
          section_id: data.section_id,
          section_name: data.section_name,
          title: data.title,
          description: data.description,
          link_type: data.link_type,
          link: data.link_type === 'custom_link' ? data.link : 0,
          external_link: data.link_type === 'external_link' ? data.link : 0,
          status: data.status,
          page_id: data.page_id,
          desktop_img: data.desktop_image,
          mobile_img: data.mobile_image,
          selectedCategoryId: data.category_id,
          section_type: data.section_type,
          MobilebtnX: xPercentMob,
          MobilebtnY: yPercentMob,
          DesktopbtnX: xPercentDesk,
          DesktopbtnY: yPercentDesk,
          desk_btn_theme:
            data.desk_btn_theme !== null ? data.desk_btn_theme : Inputs.desk_btn_theme,
          mob_btn_theme: data.mob_btn_theme !== null ? data.mob_btn_theme : Inputs.mob_btn_theme
        })
        setDesktopBtnPosition({ xPercentDesk, yPercentDesk })
        setMobileBtnPosition({ xPercentMob, yPercentMob })
        GetCategoryList(data.category_id)
        if (data.desktop_image !== '') {
          initDesktopImagePlugin(data.desktop_image)
        } else {
          initDesktopImagePlugin()
        }
        if (data.mobile_image !== '') {
          initMobileImagePlugin(data.mobile_image)
        } else {
          initMobileImagePlugin()
        }
      }
    })
  }

  const handleInputChanges = (prop) => (event) => {
    if (prop === 'status') {
      setInputs({ ...Inputs, [prop]: event.target.checked })
    } else {
      setInputs({ ...Inputs, [prop]: event.target.value })
    }
    setForceUpdate(!isForceUpdate)
  }

  const initMobileImagePlugin = (image1 = null) => {
    if (image1 !== '' && image1 !== null) {
      new FileUploadWithPreview('mobile_image', {
        text: {
          chooseFile: 'Choose Image...'
        },
        presetFiles: [image1]
      })
      setMobileImage(true)
    } else {
      new FileUploadWithPreview('mobile_image', {
        text: {
          chooseFile: 'Choose Image...'
        }
      })
    }
  }
  const initDesktopImagePlugin = (image = null) => {
    if (image !== '' && image !== null) {
      new FileUploadWithPreview('desktop_image', {
        text: {
          chooseFile: 'Choose Image...'
        },
        presetFiles: [image]
      })
      setDesktopImage(true)
    } else {
      new FileUploadWithPreview('desktop_image', {
        text: {
          chooseFile: 'Choose Image...'
        }
      })
    }
  }
  window.addEventListener('fileUploadWithPreview:imagesAdded', function (e) {
    if (e.detail.uploadId === 'desktop_image') {
      const imageType = e.detail.cachedFileArray[0].type
      const size = e.detail.cachedFileArray[0].size

      if (
        imageType === 'image/jpeg' ||
        imageType === 'image/jpg' ||
        imageType === 'image/png' ||
        imageType === 'image/webp'
      ) {
        if (size <= 2097152) {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            setDeskImg(result)
          })
          setDesktopImage(true)
          setDesktopValidFile(true)
          setDesktopImageSize(false)
          // setIsDesktopShowImageRemoveLink(true)
        } else {
          setDesktopImageSize(true)
          // setIsDesktopShowImageRemoveLink(true)
          setDesktopImage(true)
          setDeskImg('')
        }
      } else {
        setDeskImg('')
        setDesktopImage(true)
        setDesktopValidFile(false)
        setDesktopImageSize(false)
        //  setIsDesktopShowImageRemoveLink(true)
      }
    } else if (e.detail.uploadId === 'mobile_image') {
      const imageType = e.detail.cachedFileArray[0].type
      const size = e.detail.cachedFileArray[0].size

      if (
        imageType === 'image/jpeg' ||
        imageType === 'image/jpg' ||
        imageType === 'image/png' ||
        imageType === 'image/webp'
      ) {
        if (size <= 2097152) {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            setMobileImg(result)
          })
          setMobileImage(true)
          setMobileValidFile(true)
          setMobileImageSize(false)
          // setIsMobileShowImageRemoveLink(true)
        } else {
          setMobileImageSize(true)
        }
      } else {
        setMobileImg('')
        setMobileImage(true)
        setMobileValidFile(false)
      }
    }
  })

  window.addEventListener('fileUploadWithPreview:clearButtonClicked', function (e) {
    if (e.detail.uploadId === 'desktop_image') {
      setDeskImg('')
      setDesktopValidFile(true)
      setDesktopImageSize(false)
      //  setIsDesktopShowImageRemoveLink(false)
      setDesktopImage(false)
    } else if (e.detail.uploadId === 'mobile_image') {
      setMobileImg('')
      setMobileValidFile(true)
      setMobileImageSize(false)
      // setIsMobileShowImageRemoveLink(false)
    }
  })

  // const clearForm = e => {
  //     setInputs(clearInputs)
  //     setsvgUrl()
  //     clearFileRef.current.click();
  //     setForceUpdate(!isForceUpdate);
  // }

  const SubmitForm = (e) => {
    if (DeskImg === 'invalid') {
      setDesktopImage(false)
    }
    if (
      !validator.current.allValid() ||
      DeskImg === 'invalid' ||
      IsDesktopImage === false ||
      IsDesktopImageSize === true ||
      IsDesktopValidFile === false
    ) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }

    const param = {
      _id: Inputs.id,
      _section_id: Inputs.section_id,
      _section_name: Inputs.section_name,
      _description: Inputs.description,
      _link:
        Inputs.link_type === 'custom_link'
          ? Inputs.link === 0
            ? ''
            : Inputs.link
          : Inputs.link_type === 'external_link'
            ? Inputs.external_link === 0
              ? ''
              : Inputs.external_link
            : Inputs.link,
      _link_type: Inputs.link_type,
      _title: Inputs.title,
      _status: Inputs.status,
      _category_id: Inputs.selectedCategoryId,
      _page_id: Inputs.page_id,
      _desktop_img: DeskImg,
      _mobile_img: MobileImg,
      _desk_btn_theme: Inputs.desk_btn_theme,
      _mob_btn_theme: Inputs.mob_btn_theme,
      _desk_btnX: Inputs.DesktopbtnX,
      _desk_btnY: Inputs.DesktopbtnY,
      _mob_btnX: Inputs.MobilebtnX,
      _mob_btnY: Inputs.MobilebtnY
    }
    setLoading(true)
    HttpService.postApi(API.SetSectionItem, param).then((response) => {
      setLoading(false)
      if (response.data.message) {
        toast.warning(response.data.message)
        setForceUpdate(!isForceUpdate)
        return
      }
      if (urlParams.id !== undefined) toast.success(Messages.section_option_add)
      else toast.success(Messages.section_update)
      setForceUpdate(!isForceUpdate)
      history.push('/widgets/section/edit/' + Inputs.section_id)
    })
  }

  const handleMenuInputChanges = (e) => {
    setInputs({ ...Inputs, link_type: e.target.value })
    if (e.target.value === 'category') {
      setInputs({
        ...Inputs,
        page_id: Inputs.page_id === '' ? 0 : Inputs.page_id,
        link: Inputs.link === '' ? 0 : Inputs.link,
        selectedCategoryId: Inputs.selectedCategoryId === 0 ? '' : Inputs.selectedCategoryId,
        external_link: Inputs.external_link === '' ? 0 : Inputs.external_link,
        link_type: e.target.value
      })
    } else if (e.target.value === 'page') {
      setInputs({
        ...Inputs,
        link: Inputs.link === '' ? 0 : Inputs.link,
        selectedCategoryId: Inputs.selectedCategoryId === '' ? 0 : Inputs.selectedCategoryId,
        external_link: Inputs.external_link === '' ? 0 : Inputs.external_link,
        page_id: Inputs.page_id === 0 ? '' : Inputs.page_id,
        link_type: e.target.value
      })
    } else if (e.target.value === 'custom_link') {
      setInputs({
        ...Inputs,
        page_id: Inputs.page_id === '' ? 0 : Inputs.page_id,
        selectedCategoryId: Inputs.selectedCategoryId === '' ? 0 : Inputs.selectedCategoryId,
        link: Inputs.link === 0 ? '' : Inputs.link,
        link_type: e.target.value,
        external_link: Inputs.external_link === '' ? 0 : Inputs.external_link
      })
    } else if (e.target.value === 'blank') {
      setInputs({
        ...Inputs,
        page_id: 0,
        selectedCategoryId: 0,
        link: 0,
        link_type: e.target.value,
        external_link: 0
      })
    } else if (e.target.value === 'external_link') {
      setInputs({
        ...Inputs,
        page_id: Inputs.page_id === '' ? 0 : Inputs.page_id,
        selectedCategoryId: Inputs.selectedCategoryId === '' ? 0 : Inputs.selectedCategoryId,
        external_link: Inputs.external_link === 0 ? '' : Inputs.external_link,
        link: Inputs.link === '' ? 0 : Inputs.link,
        link_type: e.target.value
      })
    }
    setForceUpdate(!isForceUpdate)
  }

  const updateCategoryDropdown = () => {
    Categories.map((item, index) => {
      if (item.value === Inputs.category_id) {
        Categories[index].checked = true
      } else {
        Categories[index].checked = false
      }
      if (item.children) {
        item.children.map((subitem, subindex) => {
          if (subitem.value === Inputs.category_id) {
            Categories[index].children[subindex].checked = true
          } else {
            Categories[index].children[subindex].checked = false
          }
          if (subitem.children) {
            subitem.children.map((firstlevelsubitem, firstlevelsubindex) => {
              if (firstlevelsubitem.value === Inputs.category_id) {
                Categories[index].children[subindex].children[firstlevelsubindex].checked = true
              } else {
                Categories[index].children[subindex].children[firstlevelsubindex].checked = false
              }
              if (firstlevelsubitem.children) {
                firstlevelsubitem.children.map((secondlevelsubitem, secondlevelsubindex) => {
                  if (secondlevelsubitem.value === Inputs.category_id) {
                    Categories[index].children[subindex].children[firstlevelsubindex].children[
                      secondlevelsubindex
                    ].checked = true
                  } else {
                    Categories[index].children[subindex].children[firstlevelsubindex].children[
                      secondlevelsubindex
                    ].checked = false
                  }
                  return true
                })
              }
              return true
            })
          }
          return true
        })
      }
      return true
    })
  }

  const onChangeCategory = (currentNode, selectedNodes) => {
    if (selectedNodes.length > 0) {
      setInputs({ ...Inputs, selectedCategoryId: selectedNodes[0].value })
      Inputs.selectedCategoryId = Inputs.category_id = selectedNodes[0].value
    } else {
      setInputs({ ...Inputs, selectedCategoryId: '' })
    }
    updateCategoryDropdown()
  }

  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {urlParams.id !== undefined ? Title.EditSectionOption : Title.AddSectionOption}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            Back
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form
                className="forms-sample"
                autoComplete="off"
              >
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Title</label>
                      <input
                        type="text"
                        maxLength="255"
                        className="form-control"
                        name="title"
                        onChange={handleInputChanges('title')}
                        onKeyUp={handleInputChanges('title')}
                        onBlur={() => validator.showMessageFor('title')}
                        value={Inputs.title}
                        placeholder="Title"
                      />
                      {validator.current.message('Title', Inputs.title, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        {Inputs.section_type === 'one_column' ||
                        Inputs.section_type === 'two_column'
                          ? 'Button Text'
                          : 'Description'}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="Button Text"
                        onChange={handleInputChanges('description')}
                        value={Inputs.description}
                        placeholder={
                          Inputs.section_type === 'one_column' ||
                          Inputs.section_type === 'two_column'
                            ? 'Button Text'
                            : 'Description'
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Link Type</label>
                      <select
                        className="form-control"
                        name="link_type"
                        onChange={handleMenuInputChanges}
                        value={Inputs.link_type}
                      >
                        <option value="">Select</option>
                        <option value="category">Category</option>
                        <option value="page">Page</option>
                        <option value="custom_link">Custom Link</option>
                        <option value="external_link">External link</option>
                        <option value="blank">Blank</option>
                      </select>
                      {validator.current.message('Menu Type', Inputs.link_type, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div
                    className="col-md-6"
                    style={Inputs.link_type === 'category' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      <label>Category</label>
                      {Categories.length > 0 && (
                        <DropdownTreeSelect
                          placeholder="Choose"
                          multi={false}
                          data={Categories}
                          onChange={onChangeCategory}
                          //
                          mode="radioSelect"
                          className="bootstrap-demo w-100"
                        />
                      )}
                      <input
                        type="hidden"
                        className="form-control"
                        name="category"
                        onBlur={() => validator.current.showMessageFor('category')}
                        value={Inputs.selectedCategoryId}
                      />{' '}
                      {validator.current.message(
                        'Category',
                        Inputs.selectedCategoryId,
                        'required',
                        {
                          className: 'error'
                        }
                      )}
                    </div>
                  </div>
                  <div
                    className="col-md-6"
                    style={Inputs.link_type === 'page' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      <label>Page</label>
                      <select
                        className="form-control"
                        name="page_id"
                        onChange={handleInputChanges('page_id')}
                        onBlur={() => validator.current.showMessageFor('page')}
                        value={Inputs.page_id}
                      >
                        <option
                          key={''}
                          value={''}
                        >
                          select
                        </option>
                        {Pages.map((item) => (
                          <option
                            key={item.id}
                            value={item.id}
                          >
                            {item.title}
                          </option>
                        ))}
                      </select>
                      {validator.current.message('Page', Inputs.page_id, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div
                    className="col-md-6"
                    style={Inputs.link_type === 'custom_link' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      {' '}
                      <label>Custom Link</label>{' '}
                      <input
                        type="text"
                        className="form-control"
                        name="link"
                        onChange={handleInputChanges('link')}
                        onBlur={() => validator.current.showMessageFor('link')}
                        value={Inputs.link}
                        placeholder="Custom Link"
                      />
                      <label
                        style={{ color: '#505050' }}
                        className="note mt-1"
                      >
                        {' '}
                        {'(Do not include "https://www.example.com/" in link.)'}
                      </label>
                      {validator.current.message('Custom Link', Inputs.link, 'required|noDomain', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div
                    className="col-md-6"
                    style={Inputs.link_type === 'external_link' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      {' '}
                      <label>External Link</label>
                      <input
                        type="text"
                        className="form-control"
                        name="external_link"
                        onChange={handleInputChanges('external_link')}
                        onBlur={() => validator.current.showMessageFor('external_link')}
                        value={Inputs.external_link}
                        placeholder="External Link"
                      />
                      {validator.current.message(
                        'External Link',
                        Inputs.external_link,
                        'required',
                        {
                          className: 'error'
                        }
                      )}
                    </div>
                  </div>
                  <div
                    className="col-md-6"
                    style={
                      Inputs.link_type === 'blank' || Inputs.link_type === ''
                        ? {}
                        : { display: 'none' }
                    }
                  >
                    <div className="form-group"></div>
                  </div>
                </div>
                <div>
                  <div className="form-group mb-0">
                    <label>Image</label>
                  </div>
                  <div className="row">
                    <div className="col">
                      <label className="note">
                        {'Note:'}
                        {'For One Column size must be 1920(Width) X Auto(Height) pixels'}
                      </label>
                      <label className="note ml-1">
                        {'  '}
                        {' and for Two Column size must be 900(Width) X Auto(Height) pixels.'}
                      </label>
                      <div
                        className="custom-file-container mb-5"
                        data-upload-id="desktop_image"
                      >
                        <label>Desktop Image</label>
                        <label className="note ml-1">
                          {' '}
                          {'(Only PNG, JPEG, JPG format allowed.)'}
                        </label>
                      </div>
                      <div
                        style={!IsDesktopValidFile ? {} : { display: 'none' }}
                        className="error pt-2 pb-4"
                      >
                        {Messages.formatnotsupport}
                      </div>
                      <div
                        style={IsDesktopImageSize ? {} : { display: 'none' }}
                        className="error pt-0 pb-2"
                      >
                        File size shouldn&apos;t be greater than 2MB.
                      </div>
                      <div
                        style={IsDesktopImage ? { display: 'none' } : {}}
                        className="error pt-2 pb-4"
                      >
                        Desktop Image is required.
                      </div>
                    </div>
                    <div className="col">
                      <label className="note">
                        {'Note:'}
                        {
                          'For One Column or Two Column size must be 767(Width) X Auto(Height) pixels'
                        }
                      </label>
                      <div
                        className="custom-file-container mb-5"
                        data-upload-id="mobile_image"
                      >
                        <label>Mobile Image</label>
                        <label className="note ml-1">
                          {' '}
                          {'(Only PNG, JPEG, JPG format allowed.)'}
                        </label>
                      </div>
                      <div style={IsMobileImage ? { display: 'none' } : { display: 'block' }}>
                        <small className="error">Image is required.</small>
                      </div>

                      <div
                        style={!IsMobileValidFile ? {} : { display: 'none' }}
                        className="error pt-2 pb-4"
                      >
                        {Messages.formatnotsupport}
                      </div>
                      <div
                        style={IsMobileImageSize ? {} : { display: 'none' }}
                        className="error pt-0 pb-2"
                      >
                        File size shouldn&apos;t be greater than 2MB.
                      </div>
                    </div>
                  </div>
                  {Inputs.section_type === 'one_column' || Inputs.section_type === 'two_column' ? (
                    <div className="row">
                      <div className="col-md-6 d-none">
                        <div className="form-group">
                          <label>Desktop Button Theme</label>
                          <select
                            className="form-control"
                            name="desk_btn_theme"
                            onChange={handleInputChanges('desk_btn_theme')}
                            value={Inputs.desk_btn_theme}
                          >
                            <option value={'black'}>Black</option>
                            <option value={'white'}>White</option>
                            <option value={'theme_color'}>Theme color</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6 d-none">
                        <div className="form-group">
                          <label>Mobile Button Theme</label>
                          <select
                            className="form-control"
                            name="mob_btn_theme"
                            onChange={handleInputChanges('mob_btn_theme')}
                            value={Inputs.mob_btn_theme}
                          >
                            <option value={'black'}>Black</option>
                            <option value={'white'}>White</option>
                            <option value={'theme_color'}>Theme color</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label
                            htmlFor="exampleInputUsername2"
                            className="col-sm-12"
                          >
                            Set Desktop Button Position
                          </label>
                          <div
                            className="mt-1 px-3"
                            style={{ position: 'relative', display: 'inline-block' }}
                          >
                            <img
                              src={
                                DeskImg !== ''
                                  ? DeskImg
                                  : Common.setImage('assets/images/icon/place_holder_1.jpg')
                              }
                              ref={DesktopImageRef}
                              onClick={handleDesktopImageClick}
                              onMouseMove={handleDesktopImageHover}
                              onMouseLeave={handleDesktopImageLeave}
                              style={{
                                width: '100%',
                                cursor: 'crosshair'
                              }}
                            />
                            {desktopHoverInfo && (
                              <div
                                style={{
                                  position: 'absolute',
                                  top: `${desktopHoverInfo.yPercent}%`,
                                  left: `${desktopHoverInfo.xPercent}%`,
                                  transform: 'translate(-50%, -50%)',
                                  backgroundColor: '#FFD700',
                                  color: '#000',
                                  padding: '6px 10px',
                                  borderRadius: '5px',
                                  fontSize: '11px',
                                  fontWeight: 'bold',
                                  zIndex: 5,
                                  pointerEvents: 'none'
                                }}
                              >
                                Button
                              </div>
                            )}
                            {DesktopBtnPosition && (
                              <div
                                style={{
                                  position: 'absolute',
                                  top: `${DesktopBtnPosition.yPercentDesk}%`,
                                  left: `${DesktopBtnPosition.xPercentDesk}%`,
                                  transform: 'translate(-50%, -50%)',
                                  zIndex: 10,
                                  textAlign: 'center'
                                }}
                              >
                                <button
                                  type="button"
                                  className="btn btn-dark btn-sm"
                                  style={{ fontSize: '10px' }}
                                  onClick={handleRemoveDesktopButton}
                                  title="Click to remove"
                                >
                                  {Inputs.description}
                                </button>

                                <div
                                  style={{
                                    fontSize: '10px',
                                    background: '#FFD700',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    marginTop: '2px'
                                  }}
                                >
                                  Button
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label
                            htmlFor="exampleInputUsername2"
                            className="col-sm-12"
                          >
                            Set Mobile Button Position
                          </label>
                          <div
                            className="mt-1 px-3"
                            style={{ position: 'relative', display: 'inline-block' }}
                          >
                            <img
                              src={
                                MobileImg !== ''
                                  ? MobileImg
                                  : Common.setImage('assets/images/icon/place_holder_1.jpg')
                              }
                              ref={MobileImageRef}
                              onClick={handleMobileImageClick}
                              onMouseMove={handleMobileImageHover}
                              onMouseLeave={handleMobileImageLeave}
                              style={{
                                width: '100%',
                                cursor: 'crosshair'
                              }}
                            />
                            {mobileHoverInfo && (
                              <div
                                style={{
                                  position: 'absolute',
                                  top: `${mobileHoverInfo.yPercent}%`,
                                  left: `${mobileHoverInfo.xPercent}%`,
                                  transform: 'translate(-50%, -50%)',
                                  backgroundColor: '#FFD700',
                                  color: '#000',
                                  padding: '6px 10px',
                                  borderRadius: '5px',
                                  fontSize: '11px',
                                  fontWeight: 'bold',
                                  zIndex: 5,
                                  pointerEvents: 'none'
                                }}
                              >
                                Button
                              </div>
                            )}
                            {MobileBtnPosition && (
                              <div
                                style={{
                                  position: 'absolute',
                                  top: `${MobileBtnPosition.yPercentMob}%`,
                                  left: `${MobileBtnPosition.xPercentMob}%`,
                                  transform: 'translate(-50%, -50%)',
                                  zIndex: 10,
                                  textAlign: 'center'
                                }}
                              >
                                <button
                                  type="button"
                                  className="btn btn-dark btn-sm"
                                  style={{ fontSize: '10px' }}
                                  onClick={handleRemoveMobileButton}
                                  title="Click to remove"
                                >
                                  {Inputs.description}
                                </button>

                                <div
                                  style={{
                                    fontSize: '10px',
                                    background: '#FFD700',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    marginTop: '2px'
                                  }}
                                >
                                  Button
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges('status')}
                            id="EnableProduct"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <button
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to={'/widgets/section/edit/' + Inputs.section_id}
                      className="btn btn-primary mr-2"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddSectionOption
